import { IItemForGetShortInfo } from 'types';
import React from 'react';
import ComboItemsMultipleSelect from './components/ComboItemsMultipleSelect';
import DnDList from './components/DnDList';
import style from './ComboItemsField.module.scss';

interface IComboItemsField {
	setComboItems: (value: string[]) => void;
	setFetchedComboItems: (value: IItemForGetShortInfo[]) => void;
	updateComboItems: (value: IItemForGetShortInfo[]) => void;
	selectedRestaurants: string[];
	selectedComboItems: string[];
	fetchedComboItems: IItemForGetShortInfo[];
}

const ComboItemsField: React.FC<IComboItemsField> = ({
	fetchedComboItems,
	selectedComboItems,
	selectedRestaurants,
	setFetchedComboItems,
	setComboItems,
	updateComboItems,
}) => {
	return (
		<div className={style.container} data-test="ComboItemsField">
			<div className={style.field}>
				<ComboItemsMultipleSelect
					selectedComboItems={selectedComboItems}
					selectedRestaurants={selectedRestaurants}
					setFetchedComboItems={setFetchedComboItems}
					setComboItems={setComboItems}
					updateComboItems={updateComboItems}
				/>
			</div>
			<DnDList
				selectedComboItems={selectedComboItems}
				fetchedComboItems={fetchedComboItems}
				setComboItems={setComboItems}
			/>
		</div>
	);
};

export default React.memo(ComboItemsField);
